module.exports = __webpack_public_path__ + "media/packs/public/images/mail/password_reset/ios_download-5799d1f25f23cf2fa0564562306afddf.png";